import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    loading: false,
    activo: false,
    data: {},
    fc_06: {
        fechafolicitud: fechaHoy,
        cultivado: false,
        semicultivado: false,
        silvestre: false,
        nombrerazonSocial: '',
        calle: '',
        numerointerior: '',
        numeroexterior: '',
        localidadcolonia: '',
        municipio: '',
        distrito: '',
        estado: '',
        codigopostal: '',
        correoelectronico: '',
        telefono: ''
    },
    predios: [],
    fc_06Map: {},
    prediosMap: [],
    viverosMap: [],
    filesPrediosMap: [],
    filesViverosMap: [],
}

//types
const LOADING = 'LOADING'
const OBTENER_DETALLE_FC_06_EXITOAT = 'OBTENER_DETALLE_FC_06_EXITOAT'
const ACTUALIZAR_FC_06_ESTATUS_EXITO = 'ACTUALIZAR_FC_06_ESTATUS_EXITO'
const OBTENER_FC_06_MAP_EXITOAT = 'OBTENER_FC_06_MAP_EXITOAT'
const ACTUALIZAR_FC_06_EXITO = 'ACTUALIZAR_FC_06_EXITO'
const OBTENER_DETALLE_FC_06_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_06_CON_MAPS_EXITO'
const ACEPTAR_SOLICITUD_FC06_EXITO = 'ACEPTAR_SOLICITUD_FC06_EXITO'
const GENERAR_OFICIOS_FC06_EXITO = 'GENERAR_OFICIOS_FC06_EXITO'

const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const AGREGAR_FC_06_EXITO_MAP = 'AGREGAR_FC_06_EXITO_MAP'
const ACTUALIZAR_FC_06_MAP_EXITO = 'ACTUALIZAR_FC_06_MAP_EXITO'

export const obtenerSolicitudDetalleFC_06 = createAsyncThunk(
    OBTENER_DETALLE_FC_06_EXITOAT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_06/obtenerFormatoFC06_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_06Estatus = createAsyncThunk(
    ACTUALIZAR_FC_06_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_06Accion = createAsyncThunk(
    AGREGAR_FC_06_EXITO_MAP,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud?.[0] }
            const prediosMap = data.prediosMap
            const viverosMap = data.viveroMap
            const archivosPredioMap = data.archivosPredioMap
            const archivosViveroMap = data.archivosViveroMap


            const agregarFC_06Map = host + 'MapSolicitud/agregarMapFC_06_RegistroDeMaguey'
            const agregarMapFC_06_AnexoPredio = host + 'MapSolicitud/agregarMapFC_06_AnexoPredio'
            const agregarMapFC_06_AnexoVivero = host + 'MapSolicitud/agregarMapFC_06_AnexoVivero'
            const agregarMapFC_06_ArchivosPredios = host + 'MapSolicitud/agregarMapFC_06_ArchivosPredios'
            const agregarMapFC_06_ArchivosViveros = host + 'MapSolicitud/agregarMapFC_06_ArchivosViveros'

            const res = await axios.post(agregarFC_06Map, solicitud)

            for (const i in prediosMap) {
                await axios.post(agregarMapFC_06_AnexoPredio, { data: prediosMap[i] })
            }
            for (const i in viverosMap) {
                await axios.post(agregarMapFC_06_AnexoVivero, { data: viverosMap[i] })
            }
            for (const i in archivosPredioMap) {
                await axios.post(agregarMapFC_06_ArchivosPredios, { data: archivosPredioMap[i] })
            }
            for (const i in archivosViveroMap) {
                await axios.post(agregarMapFC_06_ArchivosViveros, { data: archivosViveroMap[i] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_06Map = createAsyncThunk(
    OBTENER_FC_06_MAP_EXITOAT,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_06_RegistroDeMaguey/${solicitudId}`
            const res = await axios.get(fullUrl)

            const prediosMap = await obtenerProductosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                prediosMap: prediosMap.anexoPrediosMap,
                viverosMap: prediosMap.anexoViverosMap,
                filesPrediosMap: prediosMap.filesPrediosMap,
                filesViverosMap: prediosMap.filesViverosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_06/obtenerFormatoFC06_ConDetalle/${idSolicitud}`

        const obtenerPredioMap = host + `MapSolicitud/obtenerMapFC_06_AnexoPredio/`
        const obtenerArchivoPredioMap = host + `MapSolicitud/obtenerMapFC_06_ArchivosPredios/`
        const obtenerViverosMap = host + `MapSolicitud/obtenerMapFC_06_AnexoVivero/`
        const obtenerArchivoViverosMap = host + `MapSolicitud/obtenerMapFC_06_ArchivosViveros/`
        const res = await axios.get(fullUrl)
        const fc_06_anexopredio = res.data.data.fc_06_anexopredio
        const fc_06_anexovivero = res.data.data.fc_06_anexovivero
        const filesPrediosMap = []
        for (const producto of fc_06_anexopredio) {
            for (const archivo of producto.fc_06archivospredio) {
                const resfiles = await axios.get(obtenerArchivoPredioMap + archivo.idfc_06archivospredio)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_06archivospredio
                    filesPrediosMap.push(resfiles.data.data)
                }
            }
        }
        let anexoPrediosMap = []
        for (const anexo of fc_06_anexopredio) {
            const resMap = await axios.get(obtenerPredioMap + anexo.idfc06_anexopredio)
            anexoPrediosMap.push(resMap.data.data)

        }
        const filesViverosMap = []
        for (const producto of fc_06_anexovivero) {
            for (const archivo of producto.fc_06archivosvivero) {
                const resfiles = await axios.get(obtenerArchivoViverosMap + archivo.idfc_06archivosvivero)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_06archivosvivero
                    filesViverosMap.push(resfiles.data.data)
                }
            }
        }
        let anexoViverosMap = []
        for (const anexo of fc_06_anexovivero) {
            const resMap = await axios.get(obtenerViverosMap + anexo.idfc06_anexovivero)
            anexoViverosMap.push(resMap.data.data)

        }

        let Map = {
            anexoPrediosMap: anexoPrediosMap, anexoViverosMap: anexoViverosMap,
            filesPrediosMap: filesPrediosMap, filesViverosMap: filesViverosMap
        }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_06Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_06_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const predios = data.predio
            const viveros = data.vivero
            const filespredios = data.archivosPredio
            const filesviveros = data.archivosVivero

            const actualizarFC_06 = host + `FC_06/actualizarFC_06`
            const urlActualizarAnexoPredios = host + 'FC_06/actualizarFormatoFC06_AnexoPredios'
            const urlActualizarAnexoViveros = host + 'FC_06/actualizarFormatoFC06_AnexoViveros'
            const urlActualizarFilesPredios = host + 'FC_06/actualizarArchivoPredioFC_06'
            const urlActualizarFilesViveros = host + 'FC_06/actualizarArchivoViveroFC_06'

            const res = await axios.put(actualizarFC_06, solicitud)

            for (let i in predios) {
                const result = await axios.put(urlActualizarAnexoPredios, { data: predios[i] })
            }
            for (let i in viveros) {
                const result = await axios.put(urlActualizarAnexoViveros, { data: viveros[i] })
            }
            for (let i in filespredios) {
                const result = await axios.put(urlActualizarFilesPredios, { data: filespredios[i] })
            }
            for (let i in filesviveros) {
                const result = await axios.put(urlActualizarFilesViveros, { data: filesviveros[i] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_06MapSolicitud = createAsyncThunk(
    ACTUALIZAR_FC_06_MAP_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud[0] }
            const prediosMap = data.prediosMap
            const viveroMap = data.viveroMap
            const archivosPredioMap = data.archivosPredioMap
            const archivosViveroMap = data.archivosViveroMap

            const actualizarFC_06 = host + 'MapSolicitud/actualizarMapFC_06_RegistroDeMaguey'
            const urlActualizarAnexoPredio = host + 'MapSolicitud/actualizarMapFC_06_AnexoPredio'
            const urlActualizarAnexoVivero = host + 'MapSolicitud/actualizarMapFC_06_AnexoVivero'
            const urlActualizarFilesPredio = host + 'MapSolicitud/actualizarMapFC_06_ArchivosPredios'
            const urlActualizarFilesVivero = host + 'MapSolicitud/actualizarMapFC_06_ArchivosViveros'

            const res = await axios.put(actualizarFC_06, solicitud)

            for (const i in prediosMap) {
                const resPredio = await axios.put(urlActualizarAnexoPredio, { data: prediosMap[i] })
            }
            for (const i in viveroMap) {
                const resPredio = await axios.put(urlActualizarAnexoVivero, { data: viveroMap[i] })
            }
            for (const i in archivosPredioMap) {
                const resPredio = await axios.put(urlActualizarFilesPredio, { data: archivosPredioMap[i] })
            }
            for (const i in archivosViveroMap) {
                const resPredio = await axios.put(urlActualizarFilesVivero, { data: archivosViveroMap[i] })
            }
            return data

        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSolicitudDetalleFC_06ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_06_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_06/obtenerFormatoFC06_ConDetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const aceptarSolicitudFC_06 = createAsyncThunk(
    ACEPTAR_SOLICITUD_FC06_EXITO,
    async (data) => {
        try {

            let { idcliente, idfc06_registromaguey, predios, viveros } = data
            const urlAgregarPredio = host + 'InformacionValida/agregarPredioCliente'
            const urlAgregarVivero = host + 'InformacionValida/agregarViveroCliente'
            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'
            
            for (let i in viveros) {
                const { id, idfc06_anexovivero, idfc06_registromaguey, fc_06archivosvivero, ...anexo } = viveros[i]
                anexo.idcliente = idcliente
                const resPredio = await axios.post(urlAgregarVivero, { data: anexo })
                for (const j in fc_06archivosvivero) {
                    const { idfc_06archivosvivero, idfc06_anexovivero, idfc06_tipoanexo, fc_06archivosviveromap, ...restFile } = fc_06archivosvivero[j]
                    restFile.nombreTabla = 'archivosviveroscliente'
                    restFile.nameFK = 'idvivero'
                    restFile.idFK = resPredio.data.data.idvivero
                    restFile.observaciones = fc_06archivosviveromap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            for (let i in predios) {
                const { id, idfc06_anexopredio, idfc06_registromaguey, fc_06archivospredio, ...anexo } = predios[i]
                anexo.idcliente = idcliente
                const resVivero = await axios.post(urlAgregarPredio, { data: anexo })
                for (const j in fc_06archivospredio) {
                    const { idfc_06archivospredio, idfc06_anexopredio, idfc06_tipoanexo, fc_06archivosprediomap, ...restFile } = fc_06archivospredio[j]
                    restFile.nombreTabla = 'archivospredioscliente'
                    restFile.nameFK = 'idpredio'
                    restFile.idFK = resVivero.data.data.idpredio
                    restFile.observaciones = fc_06archivosprediomap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarDocumentosFC_06 = createAsyncThunk(
    GENERAR_OFICIOS_FC06_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const fc06Slice = createSlice({
    name: 'fc06Slice',
    initialState: dataInicial,
    reducers: {
        resetDataFC_06(state, { payload }) {
            return dataInicial
        },
        guardarCambiosFC_06Solicitud(state, { payload }) {
            state.fc_06 = payload
        },
        agregarFC_06AnexoPredio(state, { payload }) {
            state.predios = payload
        },
        setModoVerDetalleFC_06(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_06(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_06(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [obtenerSolicitudDetalleFC_06.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [obtenerFC_06Map.fulfilled]: (state, { payload }) => {
            state.fc_06Map = payload.data
            state.prediosMap = payload.prediosMap
            state.viverosMap = payload.viverosMap
            state.filesPrediosMap = payload.filesPrediosMap
            state.filesViverosMap = payload.filesViverosMap
        },



        [agregarMapFC_06Accion.fulfilled]: (state, { payload }) => {

        },
        [actualizarFC_06Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },

        [actualizarFC_06Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_06MapSolicitud.fulfilled]: (state, { payload }) => {
        },
    },
})

//actions
export const { resetDataFC_06, guardarCambiosFC_06Solicitud, agregarFC_06AnexoPredio,
    setModoVerDetalleFC_06, setModoRecibidasCorregidasFC_06, setModoProcesoFC_06 } = fc06Slice.actions

export const FC06ReducerAtencionACliente = fc06Slice.reducer


